import {
  AccountBg1,
  bannerAud,
  bannerCad,
  bannerChf,
  bannerCny,
  bannerEur,
  bannerGbp,
  bannerHkd,
  bannerJpy,
  bannerNzd,
  bannerUsd,
} from '@/shared/assets';

export const ACC_IMAGES = {
  all: AccountBg1,
  USD: bannerUsd,
  GBP: bannerGbp,
  EUR: bannerEur,
  HKD: bannerHkd,
  NZD: bannerNzd,
  CNY: bannerCny,
  JPY: bannerJpy,
  CAD: bannerCad,
  AUD: bannerAud,
  CHF: bannerChf,
};

export const DEFAULT_IMAGE = AccountBg1;
